<script>
export default {
  name: 'Dashboards',
  data() {
    return {
      dashboards: []
    }
  },
  computed: {
    dashboardRows() {
      let rows = []
      for (let d = 0; d < this.dashboards.length; d++) {
        if (d % 3 == 0) {
          rows.push([])
        }
        rows.at(-1).push(this.dashboards[d])
      }
      return rows
    }
  },
  methods: {
    loadDashboards() {
      this.graphql(
        /* GraphQL */ `
          query lookupOptions_DashboardLookup {
            allMetricsDashBoards(orderBy: DASHBOARD_NAME_ASC) {
              nodes {
                dashboardName
                dashboardDesc
              }
            }
          }
        `
      ).then(data => {
        this.dashboards = data.allMetricsDashBoards.nodes
      })
    },
    loadDashboard(dashboardName) {
      this.$router.push({
        name: 'Dashboard',
        params: { name: dashboardName }
      })
    }
  },
  mounted() {
    this.loadDashboards()
  }
}
</script>

<template>
  <div class="p-4">
    <b-card-group
      deck
      class="w-100"
      v-for="(dashboardRow, dashboardRowIndex) in dashboardRows"
      :key="dashboardRowIndex"
    >
      <b-card
        :title="dashboard.dashboardName"
        class="m-2"
        v-for="(dashboard, dashboardIndex) in dashboardRow"
        :key="dashboardIndex"
        @click="loadDashboard(dashboard.dashboardName)"
      >
        <b-card-text>{{ dashboard.dashboardDesc }}</b-card-text>
      </b-card>
    </b-card-group>
  </div>
</template>
